module.exports = __webpack_public_path__ + "img/web_app_interface.aa5d48d2.png";